// Updated Templates.js with editable template popup
import React, { useEffect, useState } from 'react';
import './Templates.css';
import { FaEye } from 'react-icons/fa';
import QRCode from 'react-qr-code';
import { Rnd } from 'react-rnd';

import certificateImg from '../../assests/Preview.png';
import certificateImgT from '../../assests/Training.png';
import certificateImgI from '../../assests/Intern.png';
import certBack1 from '../../assests/LoginBackground.png';
import certBack2 from '../../assests/LoginBackground.png';
import certBack3 from '../../assests/LoginBackground.png';
import logo from '../../assests/EarthID Logo - Primary - BLACK.png';
import Swal from 'sweetalert2';
import Custom from './CreateCustomTemplatePage';
import CreateCustomTemplatePage from './CreateCustomTemplatePage';
import { Paintbrush } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom'
import savedCustomTemplates from '../../data/customTemplates.json';
import { getTemplatesByUserId, updateTemplate } from '../../api/certificateAPI';
import { getMe } from '../../api/loginAPI';
import { createDid, generateKeyPair, issueCredential, storeCredential } from '../../api/ssiAPI';
import { publishToHcs } from '../../api/auditAPI';


const predefinedTemplates = [
  { id: 1, name: 'CMS Certificate', image: certificateImg, background: certBack1 },
  { id: 2, name: 'Training Certificate', image: certificateImgT, background: certBack2 },
  { id: 3, name: 'Internship Certificate', image: certificateImgI, background: certBack3 },
];

const defaultStyles = {
  fontSize: 24,
  color: '#000',
  fontFamily: 'Georgia',
  textAlign: 'center',
  fontWeight: 'bold',
};

function Templates() {
  const navigate = useNavigate();
  const [selectedTemplates, setSelectedTemplates] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const [editingTemplate, setEditingTemplate] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [excelFile, setExcelFile] = useState(null);
   const [customTemplates, setCustomTemplates] = useState([]);
   const [vcAttributes, setVcAttributes] = useState([]);
   const [user, setUser] = useState(null);
const [formData, setFormData] = useState({});

useEffect(() => {
  async function fetchTemplates() {
    const me = await getMe();
      setUser(me);
    if (me?.Id) {
      try {
        const templates = await getTemplatesByUserId(me.Id);
        setCustomTemplates(templates);
        console.log('templates:', templates)
      } catch (err) {
        console.error('❌ Failed to fetch custom templates', err);
      }
    }
  }
  fetchTemplates();
}, []);


useEffect(() => {
  if (showForm && vcAttributes.length > 0 && Object.keys(formData).length === 0) {
    const initialFormData = {};
    vcAttributes.forEach(attr => {
      initialFormData[attr.key] = '';
    });
    setFormData(initialFormData);
  }
}, [showForm, vcAttributes]);


  const location = useLocation();
const method = location.state?.method || 'manual'; // default to manual
console.log(method)


  const [elements, setElements] = useState([
    { id: 'certificateName', type: 'text', value: 'Sample Certificate', x: 190, y: 180, width: 400, height: 50, styles: { ...defaultStyles } },
    { id: 'name', type: 'text', value: 'John Doe', x: 190, y: 240, width: 400, height: 50, styles: { ...defaultStyles } },
    { id: 'issuer', type: 'text', value: 'EarthID Academy', x: 190, y: 310, width: 400, height: 40, styles: { ...defaultStyles } },
    { id: 'description', type: 'text', value: 'Successfully completed the program.', x: 140, y: 380, width: 500, height: 60, styles: { ...defaultStyles, fontSize: 20 } },
    { id: 'website', type: 'text', value: 'www.myearth.id', x: 0, y: 530, width: 300, height: 30, styles: { ...defaultStyles, fontSize: 16 } },
    { id: 'qrcode', type: 'qrcode', value: 'https://earthid.net/certificate/1234', x: 600, y: 450, width: 100, height: 100 }
  ]);

  const [logoPosition, setLogoPosition] = useState({
  x: 600, y: 20, width: 150, height: 80
});


  const editTemplate = (template) => {
console.log('Editing template:', template)
  setElements(template.elements || []);
  setEditingTemplate(template);
  // Inside editTemplate:
if (template.logoPosition) {
  setLogoPosition(template.logoPosition);
}
};

  const handleTextChange = (id, value) => setElements(prev => prev.map(el => el.id === id ? { ...el, value } : el));

const saveEditedTemplate = async () => {
  if (!editingTemplate) return;

  try {
    const updatedTemplate = {
      ...editingTemplate,
      elements: editingTemplate.elements,
      logoPosition
    };

    await updateTemplate(editingTemplate.id, updatedTemplate);

    Swal.fire({
      icon: 'success',
      title: 'Template Updated',
      text: `${editingTemplate.name} has been successfully updated.`,
    });

    setEditingTemplate(null);
    // Refresh custom templates
    const me = await getMe();
    if (me?.Id) {
      const refreshed = await getTemplatesByUserId(me.Id);
      setCustomTemplates(refreshed);
    }
  } catch (err) {
    console.error('❌ Failed to update template', err);
    Swal.fire({
      icon: 'error',
      title: 'Update Failed',
      text: 'Could not save the changes. Please try again.',
    });
  }
};

const handleCardClick = async (template) => {
  setEditingTemplate(null);

  // Avoid duplicate selection
  if (!selectedTemplates.some(t => t.id === template.id)) {
    setSelectedTemplates(prev => [...prev, template]);
    setFormData(prev => ({ ...prev, template: template.name }));
  }

  try {
    const response = await fetch(`https://did.myearth.id/v2/vc-templates/${template.name}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'x-api-key': '123e4567-e89b-12d3-a456-426614174000',
      }
    });
console.log('vc template response:', response)
    if (!response.ok) throw new Error('Failed to fetch VC template');

    const data = await response.json();

    const dynamicFields = data.credentialSubject?.map(attr => ({
      name: attr.attributeName,
      label: attr.description || attr.attributeName,
      required: attr.required || false,
      type: attr.type === 'date' ? 'date' : 'text'
    })) || [];

    setVcAttributes(dynamicFields); // Save fields to render dynamically
    console.log("vcAttributes", dynamicFields);
    setShowForm(true);

  } catch (error) {
    console.error('❌ Error fetching VC Template:', error);
    Swal.fire({
      icon: 'error',
      title: 'Failed to Load Template',
      text: 'Could not fetch the selected template. Please try again later.',
      confirmButtonColor: '#3085d6'
    });
  }
};


  const handleUseTemplate = (template) => {
    setFormData(prev => ({ ...prev, template: template.name }));
    setShowForm(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setShowForm(false);

  Swal.fire({
    title: 'Issuing Certificate...',
    text: 'Please wait while we process your request.',
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading()
  });

  try {
    // 🔁 Pass entire formData dynamically
    await issueSingleVC(formData);

    const messageObj = {
      event: "Single Certificate Issuance",
      message: `Certificate is issued successfully`,
      timestamp: new Date().toISOString(),
      status: "success"
    };

    await publishToHcs(messageObj);
    console.log('Published audit for Single Certificate Issuance');

    Swal.close();
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: 'Certificate issued successfully!'
    }).then(() => {
      navigate('/certificates');
    });
  } catch (err) {
    Swal.close();
    Swal.fire('Error', err.message || 'Issuance failed', 'error');
  }
};




const issueSingleVC = async (formData) => {
  try {
    // 1. Generate key pair
    const { publicKey, privateKey } = await generateKeyPair();

    // 2. Create DID
    const { did: userDid } = await createDid(publicKey);

    // 3. Issue VC with dynamic formData
    console.log('FormData:', formData)
    const vc = await issueCredential({ userDid, ...formData });

    // 4. Store VC (you can decide which field to use as subject name or ID)
   // const subjectName = formData.name || formData.subject || 'Unnamed Subject';
    const stored = await storeCredential(user.Id, vc);

    console.log('✅ VC issued and stored successfully:', stored);
    return { did: userDid, vc, stored };
  } catch (err) {
    console.error('❌ VC issuance failed:', err.message);
    throw err;
  }
};



const handleBulkUpload = async () => {
  if (!excelFile) {
    return Swal.fire('Error', 'Please upload an Excel file.', 'error');
  }

  const formDataData = new FormData();
  formDataData.append('file', excelFile);

  Swal.fire({
    title: 'Uploading Certificates...',
    text: 'Processing Excel file...',
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading()
  });

  try {
    const response = await fetch('http://localhost:3000/upload', {
      method: 'POST',
      body: formDataData
    });

    if (!response.ok) throw new Error('Upload failed');

    const data = await response.json();

    const messageObj = {
              "event": "Bulk Certificate Issuance",
              "message": `Bulk certificates are issued successfully`,
              "timestamp": new Date().toISOString(),
              "status": "success"
            }
                await publishToHcs(messageObj)
                console.log('Published audit for Bulk Certificate Issuance')
    

    Swal.close();


    await Swal.fire({
      icon: 'success',
      title: 'Bulk Issuance Complete',
      html: `
        <p>All certificates issued successfully!</p>
        <a href="http://localhost:3000${data.downloadLink}" target="_blank" style="color:blue;text-decoration:underline;">
          📥 Download Excel File
        </a>
      `
    });

    navigate('/certificates'); // redirect after modal closes

  } catch (err) {
    console.error('❌ Upload failed:', err);
    Swal.close();
    Swal.fire('Error', 'Something went wrong during upload.', 'error');
  }
};




  return (
    <div className="templates-page">
        <h2 className='create-title'>Select Your Template</h2>
      <h2 className="templates-title">Available Templates</h2>
      <div className="templates-grid">
        {predefinedTemplates.map((template) => (
          
          <div className="template-card" key={template.id} onClick={() => handleCardClick(template)}>
            <div className="template-image-container">
              <img src={template.image} alt={template.name} className="template-image" />
              <div className="image-overlay"><FaEye className="overlay-eye" onClick={() => setPreviewImage(template.image)}/></div>
            </div>
            <h3 className="template-name">{template.name}</h3>
            <button className="add-btn" onClick={(e) => { e.stopPropagation(); editTemplate(template); }}>Edit Template</button>
          </div>
        ))}
      </div>

 {customTemplates?.length > 0 && (
  <>
    {/* <h2 className="templates-title">Custom Templates</h2> */}
    <div className="templates-grid">
      {customTemplates.map(template => (
        <div
          key={template.id}
          className="template-card"
          onClick={() => handleCardClick(template)}
        >
          <div className="template-image-container">
              <div
  className="template-preview-card"
  style={{
    width: '240px',
    height: '170px',
    position: 'relative',
    backgroundImage: `url(${template.background})`,
    backgroundSize: 'cover',
    borderRadius: '6px',
    overflow: 'hidden',
    transform: 'scale(1)', // in case you want scaling later
    transformOrigin: 'top left',
  }}
>
  {/* Logo */}
  {template.logoPosition && (
    <img
      src={template.logo}
      alt="Logo"
      style={{
        position: 'absolute',
        left: template.logoPosition.x * 0.3,
        top: template.logoPosition.y * 0.3,
        width: template.logoPosition.width * 0.3,
        height: template.logoPosition.height * 0.3,
        objectFit: 'contain'
      }}
    />
  )}

  {/* Elements */}
  {template.elements.map(el => {
    const styles = {
      position: 'absolute',
      left: el.x * 0.3,
      top: el.y * 0.3,
      width: el.width * 0.3,
      height: el.height * 0.3,
      fontSize: el.styles?.fontSize ? el.styles.fontSize * 0.3 : 7,
      color: el.styles?.color || '#000',
      fontFamily: el.styles?.fontFamily || 'sans-serif',
      fontWeight: el.styles?.fontWeight || 'normal',
      fontStyle: el.styles?.fontStyle || 'normal',
      textDecoration: el.styles?.textDecoration || 'none',
      textAlign: el.styles?.textAlign || 'center',
      overflow: 'hidden'
    };

    return (
      <div key={el.id} style={styles}>
        {el.type === 'text' ? (
          <span style={{ fontSize: styles.fontSize }}>{el.value}</span>
        ) : el.type === 'qrcode' ? (
          <QRCode value={el.value} style={{ width: '100%', height: '100%' }} />
        ) : null}
      </div>
    );
  })}
</div>

              <div className="image-overlay"><FaEye className="overlay-eye" onClick={() => setPreviewImage(template)}/></div>
            </div>
            <h3 className="template-name">{template.name}</h3>
            <button className="add-btn" onClick={(e) => { e.stopPropagation(); editTemplate(template); }}>Edit Template</button>
        </div>
      ))}
    </div>
  </>
)}


      <div
  className="create-custom-card"
  onClick={() => navigate('/create-custom-template')}
  style={{ cursor: 'pointer' }}
>
  <h3>+ Create Custom Template</h3>
  <p>Design your own certificate from scratch.</p>
</div>

      {/* Table */}
      {/* <div className="selected-templates-section">
        <h3>Selected Templates</h3>
        <table>
          <thead>
            <tr><th>Sr No</th><th>Template Name</th><th>Preview</th><th>Use Template</th></tr>
          </thead>
          <tbody>
            {selectedTemplates.map((template, index) => (
              <tr key={template.id}>
                <td>{index + 1}</td>
                <td>{template.name}</td>
                <td><FaEye className="table-eye" onClick={() => setPreviewImage(template.image)} /></td>
                <td><button className="use-btn" onClick={() => handleUseTemplate(template)}>Use</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div> */}

      {/* Preview Modal */}
      {/* {previewImage && (
        <div className="image-popup-overlay" onClick={() => setPreviewImage(null)}>
          <div className="image-popup"><img src={previewImage} alt="Preview" /></div>
        </div>
      )} */}
      {previewImage && typeof previewImage === 'object' && (
  <div className="image-popup-overlay" onClick={() => setPreviewImage(null)}>
    <div className="image-popup editor-popup landscape" style={{
      width: '800px',
      height: '565px',
      position: 'relative',
      backgroundImage: `url(${previewImage.background})`,
      backgroundSize: 'cover',
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0 0 10px rgba(0,0,0,0.2)'
    }}>
      {/* Render logo */}
      <img
        src={previewImage.logo}
        alt="Logo"
        style={{
          position: 'absolute',
          left: previewImage.logoPosition?.x || 0,
          top: previewImage.logoPosition?.y || 0,
          width: previewImage.logoPosition?.width || 100,
          height: previewImage.logoPosition?.height || 100
        }}
      />

      {/* Render elements */}
      {previewImage.elements?.map((el) => {
        const style = {
          position: 'absolute',
          left: el.x,
          top: el.y,
          width: el.width,
          height: el.height,
          ...(el.styles || {})
        };

        return (
          <div key={el.id} style={style}>
            {el.type === 'text' ? (
              <div>{el.value}</div>
            ) : el.type === 'qrcode' ? (
              <QRCode value={el.value} style={{ width: '100%', height: '100%' }} />
            ) : el.type === 'image' ? (
              <img src={el.value} style={{ width: '100%', height: '100%' }} alt="img-element" />
            ) : null}
          </div>
        );
      })}
    </div>
  </div>
)}


      {/* Edit Template Popup */}
{editingTemplate && (
  <div className="image-popup-overlay">
    <div className="image-popup editor-popup landscape">
      <div className="editor-header">
        <h3 className="editor-title">Edit Template: {editingTemplate.name}</h3>
        <button className="close-btn" onClick={() => setEditingTemplate(null)}>×</button>
      </div>
      <div
        className="preview-area"
        style={{
          backgroundImage: `url(${editingTemplate.background})`,
          position: 'relative',
          width: '800px',
          height: '565px',
          backgroundSize: 'cover',
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 0 10px rgba(0,0,0,0.2)'
        }}
      >
        {/* Dynamic logo position */}
        <Rnd
          size={{
            width: editingTemplate.logoPosition?.width || 100,
            height: editingTemplate.logoPosition?.height || 50
          }}
          position={{
            x: editingTemplate.logoPosition?.x || 670,
            y: editingTemplate.logoPosition?.y || 20
          }}
          bounds="parent"
          onDragStop={(e, d) =>
            setLogoPosition(p => ({ ...p, x: d.x, y: d.y }))
          }
          onResizeStop={(e, dir, ref, delta, pos) =>
            setLogoPosition({
              width: ref.offsetWidth,
              height: ref.offsetHeight,
              ...pos
            })
          }
        >
          <img
            src={editingTemplate.logo}
            alt="Logo"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        </Rnd>

        {/* Dynamic elements from editingTemplate */}
        {(editingTemplate.elements || []).map((el) => (
          <Rnd
            key={el.id}
            size={{ width: el.width, height: el.height }}
            position={{ x: el.x, y: el.y }}
            bounds="parent"
            onDragStop={(e, d) =>
              setEditingTemplate(prev => ({
                ...prev,
                elements: prev.elements.map(item =>
                  item.id === el.id ? { ...item, x: d.x, y: d.y } : item
                )
              }))
            }
            onResizeStop={(e, dir, ref, delta, pos) =>
              setEditingTemplate(prev => ({
                ...prev,
                elements: prev.elements.map(item =>
                  item.id === el.id
                    ? {
                        ...item,
                        width: ref.offsetWidth,
                        height: ref.offsetHeight,
                        ...pos
                      }
                    : item
                )
              }))
            }
          >
            {el.type === 'text' ? (
              <textarea
                className="editable-text"
                value={el.value}
                style={el.styles}
                onChange={(e) =>
                  setEditingTemplate(prev => ({
                    ...prev,
                    elements: prev.elements.map(item =>
                      item.id === el.id
                        ? { ...item, value: e.target.value }
                        : item
                    )
                  }))
                }
              />
            ) : el.type === 'qrcode' ? (
              <QRCode value={el.value} style={{ width: '100%', height: '100%' }} />
            ) : null}
          </Rnd>
        ))}
      </div>
      <div className="popup-actions">
        <button onClick={saveEditedTemplate} className="save-btn">Save Changes</button>
      </div>
    </div>
  </div>
)}


{showForm && method === 'manual' && (
  <div className="popup-form-overlay">
    <div className="popup-form">
      <span className="close-popup" onClick={() => setShowForm(false)}>&times;</span>
      <h3>Manual Certificate Issuance</h3>
      <form className="form-inputs" onSubmit={handleSubmit}>
        
  {vcAttributes && vcAttributes.length > 0 ? (
    vcAttributes.map((attr, index) => {
      const key = attr?.name?.trim() || `field_${index}`;

      return (
        <label key={key || index}>
          {attr.label || key}:
          <input
  type={key.toLowerCase().includes('date') ? 'date' : 'text'}
  name={key}
  value={formData[key] || ''}
  onChange={(e) => {
    console.log('Updating:', e.target.name, '->', e.target.value);
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  }}
/>

        </label>
      );
    })
  ) : (
    <p>No fields available for this template.</p>
  )}

  <label>
    Template: <strong>{formData.template || 'Not selected'}</strong>
  </label>

  <div className="popup-buttons center-submit">
    <button type="submit" className="submit-btn">Issue Certificate</button>
  </div>
</form>

    </div>
  </div>
)}



{showForm && method === 'bulk' && (
  <div className="popup-form-overlay">
    <div className="popup-form">
      <span className="close-popup" onClick={() => setShowForm(false)}>&times;</span>
      <h3>Bulk Certificate Issuance</h3>

      <p className="instruction-text">
        Please upload an Excel file with the required fields. You can download a sample format below:
      </p>

      <button
        className="download-sample-btn"
        onClick={() => navigate('/upload-excel')}
      >
        📥 Download Sample Excel
      </button>
      <hr className='popup-hr'/>
      <form onSubmit={(e) => {
        e.preventDefault();
        if (!excelFile) {
          return Swal.fire('Error', 'Please upload an Excel file.', 'error');
        }
        Swal.fire({
  title: 'Uploading Certificates...',
  text: 'Processing Excel file...',
  allowOutsideClick: false,
  didOpen: () => {
    Swal.showLoading();
    setTimeout(() => {
      Swal.close();
      Swal.fire({
        icon: 'success',
        title: 'Bulk Issuance Complete',
        text: 'All certificates issued successfully!'
      }).then(() => {
        navigate('/certificates');
      });
    }, 5000); // 5 seconds delay
  }
});

        setShowForm(false);
      }}>
        <label>Upload Excel File:
          <input type="file" accept=".xlsx,.xls" onChange={e => setExcelFile(e.target.files[0])} />
        </label>
        <label>Template: <strong>{formData.template || 'Not selected'}</strong></label>
        <div className="popup-buttons center-submit">
          <button type="submit" className="submit-btn" onClick={handleBulkUpload}>Upload & Issue</button>
        </div>
      </form>
    </div>
  </div>
)}


      
    </div>
  );
}

export default Templates;